import { LogHelper } from 'com-gyf-webcore-loghelper';
import {
    GET_CONFIGURACION_CONTRASENA_START,
    GET_CONFIGURACION_CONTRASENA_SUCCESS,
    ERROR_MESSAGE,
    ACTUALIZAR_CONTRASENA,
    ACTUALIZAR_CONTRASENA_SUCCESS,
    ACTUALIZAR_CONTRASENA_FAIL,
    RESET_CAMBIO_CONTRASENA
} from '../../Screens/CambioContrasena/actions/ChangePasswordActions';

const initialState = {
    configuracionContrasena: [],
    isFetching: false,
    routeToLogin: false,
    mensaje: null,
    exitoCambioPass: false
}

export function cambioContrasena(state = initialState, action) {
    LogHelper.In(cambioContrasena.name, state, action);

    switch (action.type) {

        case GET_CONFIGURACION_CONTRASENA_START:
            LogHelper.Out(cambioContrasena.name);
            return { ...state, isFetching: true };

        case GET_CONFIGURACION_CONTRASENA_SUCCESS:
            LogHelper.Out(cambioContrasena.name);
            return {
                ...state,
                isFetching: false,
                configuracionContrasena: action.validaciones
            };

        case ACTUALIZAR_CONTRASENA:
            return {
                ...state,
                isFetching: true,
            };

        case ACTUALIZAR_CONTRASENA_SUCCESS:
            return {
                ...state,
                isFetching: false,
                routeToLogin: true,
                exitoCambioPass: true
            };

        case ACTUALIZAR_CONTRASENA_FAIL:
            return {
                ...state,
                isFetching: false,
                routeToLogin: false,
                mensaje: action.data
            };

        case RESET_CAMBIO_CONTRASENA: {
            return initialState;
        }

        default:
            LogHelper.Out(cambioContrasena.name);
            return state;
    }
}

export default cambioContrasena;


// WEBPACK FOOTER //
// ./Portico/App/store/Reducers/CambioContrasena.js